import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ReactComponent as FilledSettingsIcon } from "../../assets/fill-setting.svg";
export default function AsideMenuItems({ Icon, title, to }) {
  const path = useLocation().pathname;
  return (
    <>
      {to === "/settings" && path.startsWith("/settings") ? (
        <NavLink
          to={to}
          className={({ isActive }) => (isActive ? "active-link" : "text-gray")}
        >
          <li className="d-flex gap-3 align-items-center pb-4">
            {<FilledSettingsIcon />}
            <span> {title}</span>
          </li>
        </NavLink>
      ) : (
        <NavLink
          to={to}
          className={({ isActive }) => (isActive ? "active-link" : "text-gray")}
        >
          <li className="d-flex gap-3 align-items-center pb-4">
            {typeof Icon === "string" ? (
              <img src={Icon} alt="" className="menu-icon" />
            ) : (
              <Icon className="menu-icon" />
            )}
            <span> {title}</span>
          </li>
        </NavLink>
      )}
    </>
  );
}
